<template>
  <div>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header> Products Filter </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-layout row wrap align-start>
            <v-flex xs12>
            <ClientFilter
              :getSelectedFilters="getSelectedFilters"
              @selectedClient="selectedClient"
              @updateByFilters="updateByFilters"
            />
            </v-flex>
            <v-flex xs12 lg5>
              <SellersDomainsFilter
                :sellerIds="sellerIds"
                @selectedSellers="selectedSellers"
                @selectedDomains="selectedDomains"
              />
            </v-flex>
            <v-flex xs12 lg7>
              <CharacteristicsFilter
                :loading="loading"
                :filters="filters"
                :clientSelected="clientSelected"
                :getSelectedFilters="getSelectedFilters"
                :getFilterPayload="getFilterPayload"
                @updateByFilters="updateByFilters"
                @loadProducts="$emit('loadProducts')"
              />
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
/* eslint-disable */
import ClientFilter from "./ClientFilter";
import SellersDomainsFilter from "./SellersDomainsFilter";
import CharacteristicsFilter from "./CharacteristicsFilter";

export default {
  name: "ProductFilter",
  components: {
    ClientFilter,
    SellersDomainsFilter,
    CharacteristicsFilter,
  },
  props: {
    clientId: Number | String,
    sellerIds: {
      type: Array,
      default: null,
    },
    domainIds: {
      type: Array,
      default: null,
    },
    clientSelected: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    panel: 0,
    filters: {
      brand: {
        isLoading: false,
        search: null,
      },
      category: {
        isLoading: false,
        search: null,
      },
      product: {
        isLoading: false,
        search: null,
      },
      sku: {
        isLoading: false,
        search: null,
      },
      ean: {
        isLoading: false,
        search: null,
      },
      allowRequest: true,
    },
    sellerInvert: false,
  }),
  methods: {
    updateByFilters(e, key) {
      if (!this.filters.allowRequest) return;
      this.$store.commit("productModule/SET_selectedFilters", {
        value: e,
        key: key,
      });
    },
    selectedClient(id) {
      this.$emit("selectedClient", id);
    },
    selectedSellers(data) {
      this.$emit("selectedSellers", data);
    },
    selectedDomains(data) {
      this.$emit("selectedDomains", data);
    },
    getFilterPayload(filterTarget) {
      return {
        filterTarget,
        client_selection: this.clientId,
        seller_selection: this.sellerIds,
        domain_selection: this.domainIds,
        brand_selection: this.getSelectedFilters.brand,
        name_selection: this.getSelectedFilters.product,
        category_selection: this.getSelectedFilters.category,
        sku_selection: this.getSelectedFilters.sku,
        ean_selection: this.getSelectedFilters.ean,
      };
    },
  },
  computed: {
    getSelectedFilters() {
      return this.$store.state.productModule.selectedFilters;
    },
  },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/product/ProductFilter.vue